import "./login.layout.scoped.sass";
import React from "react";
import { useTranslation } from "react-i18next";

export const LoginLayout = (props: any) => {
  const [t] = useTranslation();
  const loginImage = "/login.png";
  return (
    <div className="login-layout">
      <div className="login-form">
        <div>
          {props.children}
        </div>
      </div>
      <div className="panel">
        <div className="content">
          <img className="login-image" src={loginImage} alt="login" />
          <div className="title">CleanTagger</div>
          <div className="text">
            {t(
              "simple quality control of cleaning services and their hourly records"
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
